// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"jOIO38","manageStorageBox":"TO6pbc","manageStorageBtn":"kvhYM0","purple":"QixeN1"};